import { useTranslation } from "react-i18next";
import { formatDateRange } from "src/utils/dates";

export default function Info({ price, priceNote, date, dateEnd }) {
  const { t, i18n } = useTranslation();

  const stats = [
    // Цена у японских туров фиксированная за человека, поэтому под ней стоит
    // подпись из админки («на 1 человека»), а не слово «от».
    { name: t("actInfo.price"), stat: price, note: priceNote },
    // Даты показываем диапазоном: «18–25 ноября 2026».
    { name: t("actInfo.date"), stat: formatDateRange(date, dateEnd, i18n.language) },
  ].filter((item) => item.stat);

  return (
    // Цена и даты стоят рядом, а не столбиком. `lg:grid-cols-1` растягивал
    // их в две тумбы одна под другой: слева получалась башня из трёх рамок,
    // справа — пустой квадрат галереи. Рядом они и читаются вместе («сколько
    // и когда»), и оставляют воздух, ради которого всё затевалось.
    <dl className="grid grid-cols-1 xs:grid-cols-2 gap-4 sm:gap-5 mt-8 sm:mt-10">
      {stats.map((item) => (
        <div
          key={item.name}
          className="px-4 py-4 bg-kj-card border border-kj-line rounded-xl overflow-hidden sm:p-6"
        >
          {/* было truncate: казахское «Ауа райы»/японское заглавие обрезалось
              многоточием вместо переноса на вторую строку */}
          <dt className="text-xs font-bold uppercase tracking-[0.1em] text-kj-sub">
            {item.name}
          </dt>
          <dd className="mt-1 text-xl sm:text-2xl md:text-3xl font-extrabold text-kj-ink break-words">
            {item.stat}
          </dd>
          {item.note && (
            <p className="mt-1 text-xs sm:text-sm text-kj-sub">{item.note}</p>
          )}
        </div>
      ))}
    </dl>
  );
}
